import React, { useState, useEffect } from "react";
import axios from 'axios';
import { Config } from '../.env.js';
import { useLocation, useNavigate } from "react-router-dom";
import logo from "./img/Logo (1).png";
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import Table from "./masterTable";
import CampaignForm from "./CampaignCreateForm";
import AA from "./AA";
import Form from './orderForm';
import Live from './livemanger.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import InviteForm from '../pages/userRole';
// import Modal from '../pages/invite';
// import UserTable from '../pages/userTable';

library.add(fas);
const CampaignManger = () => {
    const loggedInUserName = localStorage.getItem('loggedInUserName');
    console.log("Logged in user name:", loggedInUserName)
    // console.log(loggedInUserName)
    const [showCreateCampaignForm, setShowCreateCampaignForm] = useState(false);
    const [showBrandApplications, setShowBrandApplications] = useState(false);
    const [showInfluencerApplications, setShowInfluencerApplications] = useState(false);
    const [showShortlistedInfluencers, setShowShortlistedInfluencers] = useState(false);
    const [menuVisible, setMenuVisible] = useState(false);
    const [PhoneNumber, setPhoneNumber] = useState("");
    const [WhatsappNumber, setWhatsappNumber] = useState("");
    const [UserName, setUserName] = useState("");
    const [Email, setemail] = useState("");
    const [MobileNumber, setmobilenumber] = useState("");
    const [currentUser, setCurrentUser] = useState(null);
    // const [showAllCampaign, setShowAllCampaign] = useState(true);
    const [managerName, setManagerName] = useState('');
    const [campaigns, setCampaigns] = useState([]);
    const [filteredCampaigns, setFilteredCampaigns] = useState([]); // Store filtered campaigns
    // const [UserName, setUserName] = useState("");
    const navigate = useNavigate();
    const handleApproval = (index) => {
        console.log(`Deliverables approved for row ${index + 1}`);
    };

    const [showAllCampaign, setShowAllCampaign] = useState(true);
    const handleShowAllCampignClick = () => {
        setShowAllCampaign(true);
        setShowCreateCampaignForm(false);
        setShowInfluencerApplications(false);
        setShowShortlistedInfluencers(false);
    };




    const handleCreateNewCampaignClick = () => {
        setShowCreateCampaignForm(true);
        setShowBrandApplications(false);
        setShowInfluencerApplications(false);
        setShowShortlistedInfluencers(false);
    };

    const handleShortlistedInfluencersClick = () => {
        setShowShortlistedInfluencers(true);
        setShowCreateCampaignForm(false);
        setShowBrandApplications(false);
        setShowInfluencerApplications(false);
    };
    const [showUserRoles, setShowUserRoles] = useState(false);


    const location = useLocation();




    const [isActive, setIsActive] = useState(false);

    const toggleMenu = () => {
        setIsActive(!isActive);
    };

    const handleMouseEnter = () => {
        setIsActive(true);
    };

    const handleMouseLeave = () => {
        setIsActive(false);
    };
    // useEffect(() => {
    //     const fetchCampaigns = async () => {
    //         try {
    //             const response = await axios.get(`${Config.API_URL}/api/getcampaignbymanger?managerName=${loggedInUserName}`);
    //             const allCampaigns = response.data;

    //             const managerCampaigns = allCampaigns
    //                 .filter(campaign =>
    //                     campaign.managers?.some(m => m.toLowerCase() === loggedInUserName?.toLowerCase())
    //                 )
    //                 .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // 👈 Sort newest first

    //             setCampaigns(managerCampaigns);
    //             setFilteredCampaigns(managerCampaigns);
    //         } catch (error) {
    //             console.error('Error fetching campaigns:', error);
    //         }
    //     };

    //     if (loggedInUserName) {
    //         fetchCampaigns();
    //     }
    // }, [loggedInUserName]);
    useEffect(() => {
        const storedUserName = localStorage.getItem('loggedInUserName');
        if (!storedUserName) return; // Don't run fetch if not available

        const fetchCampaigns = async () => {
            try {
                const response = await axios.get(`${Config.API_URL}/api/getcampaignbymanger?managerName=${storedUserName}`);
                const allCampaigns = response.data;

                const managerCampaigns = allCampaigns
                    .filter(campaign =>
                        campaign.managers?.some(m => m.toLowerCase() === storedUserName.toLowerCase())
                    )
                    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

                setCampaigns(managerCampaigns);
                setFilteredCampaigns(managerCampaigns);
            } catch (error) {
                console.error('Error fetching campaigns:', error);
            }
        };

        fetchCampaigns();
    }, []);


    const handleLogout = () => {
        localStorage.removeItem("userToken");
        navigate('/signin', { replace: true });
    };
    return (
        // <div className='imgfull'>
        <nav className="navbar" role="navigation" aria-label="main navigation">
            {/* <div className="top-right-logout">
                <button
                    className="button is-danger"
                    onClick={() => {
                        localStorage.removeItem("authToken");
                        localStorage.removeItem("loggedInUserName");
                        localStorage.removeItem("isSignedUp"); // ✅ Clear login state
                        localStorage.removeItem("isLoggedIn");
                        navigate('/review-login');
                    }}
                >
                    Logout
                </button>
            </div> */}
            <div className="navbar-brand">
                {/* Sidebar */}
                <a className="navbar-item" >
                    {/* <span className="icon mr-3">
                        // <img className="ml-5" src="./images/hobo.jpeg" alt="Menu Icon" />
                    </span> */}
                </a>
            </div>
            <div >

                <div className={`navbar-menu ${isActive ? 'is-active' : ''}`} style={{ backgroundColor: 'dark-blue' }}>
                    <aside className={` menu  ${isActive ? '' : 'is-hidden'} overflow-hidden`}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        <ul className="menu-list d-flex flex-row-reverse" >
                            <div className=' has-text-left ml-3'  >
                                <figure className="image is-48x48" >
                                    <img src={logo} alt="Logo" />
                                </figure>
                                {/* <li className='my-5 has-text-white' onClick={handleCreateNewCampaignClick} style={{ whiteSpace: 'nowrap' }}>
                                    <MenuItem title="Create New Campaign" icon="fas fa-plus" />
                                </li> */}
                                {/* <li className='my-5 has-text-white ml-4' onClick={handleShortlistedInfluencersClick}>
                                    <MenuItem title="Table for influencers" icon="fas fa-plus" />
                                </li> */}


                                <li className='my-5 has-text-white ml-4' onClick={handleShowAllCampignClick}>
                                    <MenuItem title=" All Campaigns" icon="fas fa-clipboard-list" />
                                </li>
                                <li className='my-5 has-text-white  ml-4' onClick={handleLogout}>
                                    <MenuItem title="Logout" icon="fas fa-sign-out-alt" />
                                </li>

                            </div>
                        </ul>
                    </aside>
                </div>

            </div >
            <ul className="menu1   d-flex flex-row-reverse"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >


                {!isActive && (
                    <div className=' has-text-centered '>
                        <figure className="image is-32x32" >
                            <img src={logo} alt="Logo" />
                        </figure>
                        {!isActive && (
                            <div className='my-5 has-text-white ml-4'>
                                <MenuItem icon="fas fa-clipboard-list" clickHandler={handleCreateNewCampaignClick} style={{ marginLeft: "90px", marginTop: "20px" }} />
                            </div>
                        )}
                        {!isActive && (
                            <div className='my-5 has-text-white ml-4'>
                                <MenuItem icon="fas fa-sign-out-alt" clickHandler={handleShortlistedInfluencersClick} style={{ merginButton: "20vw" }} />
                            </div>
                        )}

                        {!isActive && (
                            <div className='has-text-white'>
                                <div className='my-5 has-text-white ml-4'>
                                </div>
                            </div>

                        )}
                    </div>
                )}
                {/* <MenuItem icon="fas fa-check-circle" clickHandler={handleLogout} /> */}
                {!isActive && (
                    <li className="ml-5 my-2" style={{ cursor: "pointer", }}>

                        {/* <span className="icon is-small has-text-success">
                            <i className="fas fa-cog" style={{ marginRight: "90px" }} ></i>
                        </span> */}

                    </li>
                )}
            </ul>
            {/* </div > */}



            {/* Main content */}
            < div className="column" >
                <div className="columns is-ancestor">
                    <div className="column  mt-5">
                        {/* Campaigns for: {loggedInUserName} */}

                        {showCreateCampaignForm ? (
                            // Render the Create Campaign form
                            <div className="is-child  has-text-centered" style={{ height: '100vh', width: '50vw', marginLeft: '250px' }}>

                                {/* <CampaignForm /> */}

                            </div>
                        ) : showAllCampaign ? (
                            <div className='subtitle' style={{ fontSize: '15px', marginLeft: '137px' }}>
                                {filteredCampaigns.length === 0 ? (
                                    <p className="has-text-danger">No campaigns assigned to this manager.</p>
                                ) : (
                                    <Live campaigns={filteredCampaigns} />
                                )}
                            </div>
                        ) : (
                            <div className='subtitle' style={{ fontSize: '15px', marginLeft: "90px" }}>
                            </div>
                        )}
                    </div>
                </div>
            </ div>
        </nav >
        // </div>
    )
}
function MenuItem({ title, icon, clickHandler }) {
    return (
        <li className="ml-2 my-2" style={{ cursor: "pointer" }} onClick={clickHandler}>
            <span className="icon is-small has-text-success mr-1">
                {/* {icon && <FontAwesomeIcon icon={icon} />} */}
                <i className={icon} style={{ marginRight: "50px" }}></i>
            </span>
            <span style={{ marginLeft: "-25px" }}>{title}</span>
        </li>
    );
}

export default CampaignManger;
